// Placeholder variables for build process
window.userbirdq = window.userbirdq || []
window.userbird =
  window.userbird ||
  (() => {
    let userbirdq = window.userbirdq
    // Intercept dataLayer.push for all events
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      const originalPush = window.dataLayer.push

      window.dataLayer.push = function (event) {
        originalPush.apply(this, arguments)

        // Skip if no event or if it's a GTM event (starts with gtm.)
        if (!event?.event || event.event.startsWith('gtm.')) return

        // Handle purchase events specially
        if (event.event === 'purchase' && event.ecommerce?.items) {
          event.ecommerce.items.forEach((item) =>
            userbirdq.push([
              'revenue',
              {
                amount: event.ecommerce.value || 0,
                currency: event.ecommerce.currency || 'USD',
                product: item.item_name || item.item_id || 'Unknown',
                quantity: item.quantity || 1,
              },
            ]),
          )
        } else {
          // Handle all other events as custom events
          let eventData = { event_name: event.event, ...event }
          delete eventData.event
          // Skip if event name is empty, null or undefined
          if (!eventData.event_name?.trim()) return
          userbirdq.push(['custom_event', eventData])
        }
      }
    }

    var script =
      document.currentScript ||
      document.querySelector('script[src="https://cdn.userbird.com/analytics.min.js"]')
    var siteId = (function () {
      var id = window.__userbirdConfig
      if (!id) {
        id = script.getAttribute('data-site')
      }
      return id
    })()
    var heatMap = []
    var pageInfo = {}
    var events = []
    var maxScrollDepth = 0
    var external
    var attachedHandlers = {
      links: [],
      forms: [],
      downloads: [],
    }
    var trackFileExtensions = [
      'pdf',
      'xlsx',
      'docx',
      'txt',
      'rtf',
      'csv',
      'exe',
      'key',
      'pps',
      'ppt',
      'pptx',
      '7z',
      'pkg',
      'rar',
      'gz',
      'zip',
      'avi',
      'mov',
      'mp4',
      'mpeg',
      'wmv',
      'midi',
      'mp3',
      'wav',
      'wma',
      'dmg',
    ]

    var excludedDomains = [
      'gtm-msr.appspot.com',
      ...((
        script.getAttribute('data-excluded-domains') || script.getAttribute('excluded-domains')
      )?.split(',') ?? []),
      ...(window.__userbirdConfig?.excludedDomains || []),
    ]

    const botUserAgents = [
      'googlebot',
      'bingbot',
      'slurp',
      'duckduckbot',
      'baiduspider',
      'yandexbot',
      'facebookexternalhit',
      'twitterbot',
      'rogerbot',
      'linkedinbot',
      'embedly',
      'quora link preview',
      'showyoubot',
      'outbrain',
      'pinterest/0.',
      'developers.google.com/+/web/snippet',
      'slackbot',
      'vkshare',
      'w3c_validator',
      'redditbot',
      'applebot',
      'whatsapp',
      'flipboard',
      'tumblr',
      'bitlybot',
      'skypeuripreview',
      'nuzzel',
      'discordbot',
      'google page speed',
      'qwantify',
      'pinterestbot',
      'bitrix link preview',
      'xing-contenttabreceiver',
      'chrome-lighthouse',
      'telegrambot',
      'ahrefsbot',
      'semrushbot',
      'mj12bot',
      'dotbot',
      'screaming frog',
      'serpstatbot',
      'seobility',
      'sitechecker',
      'searchmetricsbot',
      'linkdexbot',
      'exabot',
      'spbot',
      'uptimerobot',
      'statuscheck',
      'pingdom',
      'gtmetrix',
      'hanaleibot',
    ]

    function isBot() {
      const userAgent = navigator.userAgent.toLowerCase()
      return botUserAgents.some((bot) => userAgent.includes(bot))
    }

    function isTrackingEnabled() {
      const { hostname, pathname } = window.location
      return pathname && hostname && siteId && !excludedDomains.includes(hostname) && !isBot()
    }

    function initializeScrollDepth() {
      const { scrollHeight } = document.documentElement
      const viewportHeight = window.innerHeight

      maxScrollDepth = Math.min((viewportHeight / scrollHeight) * 100, 100)
    }
    function updateScrollDepth() {
      const { scrollHeight } = document.documentElement
      const viewportHeight = window.innerHeight

      const currentScrollDepth =
        scrollHeight === 0
          ? null
          : scrollHeight <= viewportHeight
          ? 100 // Non-scrollable or fully visible page
          : (Math.min(window.scrollY + viewportHeight, scrollHeight) / scrollHeight) * 100
      maxScrollDepth = Math.min(Math.max(maxScrollDepth, currentScrollDepth), 100)
    }

    const handleExternalLink = () => {
      // Remove old handlers
      attachedHandlers.links.forEach(({ element, handler }) => {
        element.removeEventListener('click', handler)
      })
      attachedHandlers.links = []

      document.querySelectorAll('a').forEach((link) => {
        const handler = function (event) {
          const linkUrl = new URL(link.getAttribute('href'), window.location.href)
          const currentHostname = window.location.hostname
          if (!linkUrl) return

          // ignore file downloads
          const fileExtension = linkUrl.pathname.split('.').pop().toLowerCase()
          if (trackFileExtensions.includes(fileExtension)) {
            return
          }
          // track only external links
          if (
            linkUrl.hostname !== currentHostname &&
            link.href !== undefined &&
            link.href !== 'undefined'
          ) {
            event.preventDefault()
            external = linkUrl
            userbirdq.push([
              'external_link',
              {
                external_link: external,
              },
            ])

            // window.location.href = link.href

            // Check if link should open in a new tab
            if (link.target === '_blank') {
              window.open(link.href, '_blank')
            } else {
              window.location.href = link.href
            }
          }
        }
        link.addEventListener('click', handler)
        attachedHandlers.links.push({ element: link, handler })
      })
    }

    const handleFileDownload = () => {
      function trackDownload(url) {
        var fileUrl = url
        userbirdq.push(['file_download', { fileUrl }])
      }

      // Remove old handler
      if (attachedHandlers.downloads.length > 0) {
        attachedHandlers.downloads.forEach(({ element, handler }) => {
          element.removeEventListener('click', handler)
        })
        attachedHandlers.downloads = []
      }

      // Track Downloads from <a/> clicks
      const downloadHandler = (e) => {
        var target = e.target.closest('a')
        if (target && target.href) {
          var fileExt = target.href.split('.').pop()
          if (trackFileExtensions.includes(fileExt)) {
            trackDownload(target.href)
          }
        }
      }
      document.addEventListener('click', downloadHandler)
      attachedHandlers.downloads.push({ element: document, handler: downloadHandler })
    }

    const handleFormSubmit = () => {
      const getFormName = (form) => {
        if (form.getAttribute('id')) return form.getAttribute('id')
        else if (form.getAttribute('name')) return form.getAttribute('name')
        else return `Form on ${window.location.pathname}`
      }

      // Remove old handlers
      attachedHandlers.forms.forEach(({ element, handler }) => {
        element.removeEventListener('submit', handler)
      })
      attachedHandlers.forms = []

      document.querySelectorAll('form').forEach((form) => {
        const handler = function (event) {
          const form_name = getFormName(form)
          userbirdq.push([
            'form_submit',
            {
              form_name,
            },
          ])
        }
        form.addEventListener('submit', handler)
        attachedHandlers.forms.push({ element: form, handler })
      })
    }

    const sendAnalyticsBeacon = (params) => {
      if (!isTrackingEnabled()) {
        return
      }
      const events = params.events ?? []
      params.events = events.length
        ? encodeURIComponent(JSON.stringify(events))
        : encodeURIComponent('[]')

      params.cid = Math.floor(1e8 * Math.random()) + 1
      params.sid = siteId
      const searchParams = new URLSearchParams(params).toString()
      const url = 'https://alice.userbird.com/' + '?' + searchParams

      navigator.sendBeacon(url)
    }
    const historyBasedTracking = () => {
      if (history) {
        initializeScrollDepth()
        handleExternalLink()
        handleFormSubmit()
        handleFileDownload()

        const __USERBIRD_LOCATION_CHANGE__ = 'locationChange.userbird.production' // DO NOT MANGLE
        const originalPushState = history.pushState
        history.pushState = function (...args) {
          const result = originalPushState.apply(history, args)
          window.dispatchEvent(new Event('pushstate'))
          window.dispatchEvent(new Event(__USERBIRD_LOCATION_CHANGE__))
          return result
        }

        window.addEventListener('popstate', () => {
          window.dispatchEvent(new Event(__USERBIRD_LOCATION_CHANGE__))
        })

        window.addEventListener(__USERBIRD_LOCATION_CHANGE__, () => {
          const navigationTiming = performance.getEntriesByType('navigation')[0]
          const timeSpent = (performance.now() - navigationTiming.domContentLoadedEventEnd) / 1000

          const searchParams = new URLSearchParams(window.location.search)
          const searchParamsObj = Object.fromEntries(searchParams)
          userbirdq.push([
            'page_view',
            {
              ...pageInfo,
              scroll_depth: maxScrollDepth,
              time_spent: timeSpent ?? 0,
              heat_map: JSON.stringify(heatMap),
              timestamp: Date.now(),
              viewport_height: document.documentElement.scrollHeight,
              viewport_width: document.documentElement.clientWidth,
            },
          ])
          sendAnalyticsBeacon({ events: userbirdq })
          userbirdq.length = 0
          window.userbirdq.length = 0
          pageInfo = {
            host: window.location.hostname,
            path: window.location.pathname,
            ...(document.referrer && { referer: document.referrer }),
            ...searchParamsObj,
          }
          initializeScrollDepth()
          embedScripts()
        })
      }
    }
    function embedScripts(){
      fetch(`__SITE_API_URL__/site/${siteId}.json`)
        .then(async (res) => {
          const response = await res.json()
          embedSessionRecordingScript(response?.settings?.session_recording)
          embedToolbarScript(response?.settings?.show_toolbar)
        })
        .catch((error) => console.log('embedScripts error', error))
    }
    function embedSessionRecordingScript(session_recording){
      const isSessionRecordingScript = document.querySelector(
        'script[src="__SESSION_RECORDING_URL__"]',
      )
      if(session_recording === true || session_recording === 'true'){
        if(isSessionRecordingScript) return

        const rrwebscript = document.createElement('script')
        rrwebscript.src = 'https://cdn.jsdelivr.net/npm/rrweb@latest/dist/rrweb.min.js'
        rrwebscript.defer = true;
        document.head.appendChild(rrwebscript)


        const script = document.createElement('script')
        script.src = '__SESSION_RECORDING_URL__'
        script.setAttribute('data-site', siteId)
        script.defer = true;
        document.head.appendChild(script)
      }else{
        if(isSessionRecordingScript){
          // Remove session recording script
          isSessionRecordingScript.remove()
          
          // Remove rrweb script if it exists
          const rrwebScript = document.querySelector('script[src*="rrweb"]')
          if(rrwebScript){
            rrwebScript.remove()
          }
        }
      }
    }
    function embedToolbarScript(show_toolbar){
      const isToolbarScript = document.querySelector(
        'script[src="https://staging.app.userbird.com/toolbar/toolbar-widget.iife.js"]',
      )
      if(show_toolbar === true || show_toolbar === 'true'){
        if(isToolbarScript) return

        const script = document.createElement('script')
        script.src = 'https://staging.app.userbird.com/toolbar/toolbar-widget.iife.js'
        script.defer = true;
        script.onload = function () {
          // Call the widget init after it's loaded
          if (window.ToolbarWidget) {
            window.ToolbarWidget.createToolbar();
          }
        };
        document.head.appendChild(script)
      }else{  
        if(isToolbarScript){
          isToolbarScript.remove()
        }
      }
    }
    window.addEventListener('scroll', updateScrollDepth)

    if (void 0 !== history) {
      const searchParams = new URLSearchParams(window.location.search)
      const searchParamsObj = Object.fromEntries(searchParams)
      pageInfo = {
        host: window.location.hostname,
        path: window.location.pathname,
        ...(document.referrer && { referer: document.referrer }),
        ...searchParamsObj,
      }
      historyBasedTracking()
    } else {
      console.warn(
        'UserBird (https://userbird.com): History API not supported. Tracking may not work as expected.',
      )
    }

    document.addEventListener('click', (event) => {
      heatMap.push({ x: event.pageX, y: event.pageY })
    })

    function initializeAnalytics() {
      embedScripts()
      initializeScrollDepth()
      handleExternalLink()
      handleFormSubmit()
      handleFileDownload()
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAnalytics)
    } else {
      initializeAnalytics()
    }

    window.addEventListener('beforeunload', () => {
      const navigationTiming = performance.getEntriesByType('navigation')[0]
      const timeSpent = (performance.now() - navigationTiming.domContentLoadedEventEnd) / 1000

      // Send the page_view event first
      userbirdq.push([
        'page_view',
        {
          ...pageInfo,
          scroll_depth: maxScrollDepth,
          time_spent: timeSpent ?? 0,
          heat_map: JSON.stringify(heatMap),
          timestamp: Date.now(),
          viewport_height: document.documentElement.scrollHeight,
          viewport_width: document.documentElement.clientWidth,
        },
      ])

      sendAnalyticsBeacon({ events: userbirdq })
    })

    return {}
  })()